// waves-hidpi (SP2) — size a <canvas> for crisp rendering on retina (hypothesis
// 4). Backing store = cssPx * dpr; CSS box stays at logical size; context is
// scaled so callers (drawBarGrid) keep drawing in CSS coordinates.

export function setupHiDpiCanvas(
  canvas: HTMLCanvasElement,
  cssWidth: number,
  cssHeight: number,
  dpr: number,
): CanvasRenderingContext2D | null {
  const ratio = Math.max(1, dpr || 1);
  canvas.width = Math.round(cssWidth * ratio);
  canvas.height = Math.round(cssHeight * ratio);
  canvas.style.width = `${cssWidth}px`;
  canvas.style.height = `${cssHeight}px`;
  const ctx = canvas.getContext('2d');
  if (!ctx) return null;
  ctx.scale(ratio, ratio);
  return ctx;
}
